module.exports = __webpack_public_path__ + "static/media/argument.b3f71f51.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/argument.png
 ** module id = 429
 ** module chunks = 0
 **/